import API from './api';

// Admin service for user management and invitations
export const adminService = {
  // Dashboard
  getDashboard: async () => {
    const response = await API.get('/admin/dashboard');
    return response.data;
  },

  // User management
  getUsers: async () => {
    const response = await API.get('/admin/users');
    return response.data;
  },

  updateUser: async (userId, userData) => {
    const response = await API.put(`/admin/users/${userId}`, userData);
    return response.data;
  },

  // Invitation management
  sendInvite: async (inviteData) => {
    const response = await API.post('/admin/invite', inviteData);
    return response.data;
  },

  getInvitations: async () => {
    const response = await API.get('/admin/invitations');
    return response.data;
  },

  cancelInvitation: async (invitationId) => {
    const response = await API.delete(`/admin/invitations/${invitationId}`);
    return response.data;
  },

  // Accept invitation
  acceptInvitation: async (inviteData) => {
    const response = await API.post('/admin/invite/accept', inviteData);
    return response.data;
  },

  // Impersonation
  impersonateUser: async (userId) => {
    const response = await API.post(`/admin/impersonate/${userId}`);
    return response.data;
  },

  stopImpersonation: async () => {
    const response = await API.post('/admin/stop-impersonation');
    return response.data;
  },

  // Check if current user is being impersonated
  isImpersonating: () => {
    const token = localStorage.getItem('token');
    if (!token) return false;
    
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.isImpersonation === true;
    } catch (error) {
      return false;
    }
  },

  // Get impersonation context
  getImpersonationContext: () => {
    const token = localStorage.getItem('token');
    if (!token) return null;
    
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.isImpersonation) {
        return {
          impersonatedUser: payload.user,
          impersonatedBy: payload.impersonatedBy
        };
      }
      return null;
    } catch (error) {
      return null;
    }
  },

  // Return to admin account
  returnToAdmin: async () => {
    try {
      const result = await adminService.stopImpersonation();
      
      // Restore original token
      const originalToken = localStorage.getItem('originalToken');
      if (originalToken) {
        localStorage.setItem('token', originalToken);
        localStorage.removeItem('originalToken');
        localStorage.removeItem('impersonationToken');
      }
      
      return result;
    } catch (error) {
      console.error('Error returning to admin account:', error);
      throw error;
    }
  }
}; 